<template>
  <div id="page-withdraw-wait">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <div class="vx-card__title">
            <h4>
              รอทำรายการตรวจสอบ

            </h4>
            <br />
          </div>
        </div>
        <vs-button
          :disabled="
            !$store.state.AppActiveUser.permissions.withdraw.action
          "
          class="mr-6"
          size="small"
          icon-pack="feather"
          icon="icon-refresh-cw"
          color="success"
          @click="get_data()"
          >ดึงรายการถอน</vs-button
        >
        <span v-if="lastFetchTime" class="wd-last-fetch ml-3"
          >ดึงล่าสุด {{ lastFetchTime }}</span
        >
      </div>
      <vs-table stripe pagination max-items="20" search :data="data_wd">
        <template slot="thead">
          <vs-th sort-key="datetime">DATE/TIME</vs-th>
          <vs-th sort-key="username">USERNAME</vs-th>
          <vs-th sort-key="credit">CREDIT</vs-th>
          <vs-th sort-key="name">NAME</vs-th>
          <vs-th sort-key="bank">BANK</vs-th>
          <vs-th sort-key="info">INFO</vs-th>
          <vs-th> </vs-th>
          <vs-th sort-key="admin">ADMIN</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].date_time">
              {{
                moment(data[indextr].date_time).format("YYYY-MM-DD HH:mm:ss")
              }}
            </vs-td>
            <vs-td class="text-danger"
              ><router-link :to="`/member/${data[indextr].username}`">{{
                data[indextr].username
              }}</router-link></vs-td
            >
            <vs-td :data="data[indextr].amount">
              {{ currency(data[indextr].amount) }}
            </vs-td>

            <vs-td :data="data[indextr].fullname">
              {{ data[indextr].fullname }}
            </vs-td>

            <vs-td :data="data[indextr].bank">
              {{ data[indextr].bank }}
            </vs-td>
            <vs-td :data="data[indextr].info">
              {{ data[indextr].info }}
            </vs-td>
            <vs-td>
              <vs-button
                :disabled="!$store.state.AppActiveUser.permissions.withdraw.action"
                class="mx-1 mt-2"
                size="small"
                color="danger"
                type="filled"
                @click="
                  req_return_trans(
                    data[indextr].wd_id
                  )
                "
                >โยกรายการ
              </vs-button>
            </vs-td>
            <vs-td
              :data="data[indextr].admin"
              v-if="data[indextr].admin == null"
              class="text-center"
            >
              -
            </vs-td>
            <vs-td :data="data[indextr].admin" v-else>
              {{ data[indextr].admin }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

       <!-- POPUP-->
       <vs-popup
        classContent="popup-example"
        title="ย้ายรายการ"
        :active.sync="popup_confirm"
      >
        <br />
        <h2 class="text-center">กรุณกดปุ่มเพื่อ "ยืนยัน" หากต้องการนำรายการนี้กลับไปหน้า "รอทำรายการ"</h2>
        <br>


        <div class="text-center">
          <vs-button
          @click="confirm(withdrawdata.username, withdrawdata.wd_id)"
          color="success"
          type="filled"
          >ยืนยัน
        </vs-button>
        </div>

      </vs-popup>

    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'

import axios from '../../axios'
import moment from 'moment'

import ConfirmPopup from '@/components/withdraw/ConfirmPopup.vue'
import ClearOtpPopup from '@/components/withdraw/ClearOtpPopup.vue'
import KKPBankPopup from '@/components/withdraw/KKPBankPopup.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    moment,
    flatPickr,
    CellRendererActions,
    ConfirmPopup,
    ClearOtpPopup,
    KKPBankPopup
  },
  data () {
    return {
      data_wd : [],
      get_data_wd : [],
      withdrawdata : {},
      popup_confirm : false,
      lastFetchTime : ''
      // webname: process.env.VUE_APP_TITLE,


    }
  },
  watch: {
    async $route (to, from) {
      if (to.params.id !== from.params.id) {
        window.location.reload()
      }
    }
  },
  methods: {
    async get_data () {

      // GET  waiting withdraw data
      await axios
        .get(
          'withdraw/waitwithdraw/0/pendingVerify'
        )
        .then((response) => (this.get_data_wd = response.data))
      this.data_wd = this.get_data_wd.data
      this.lastFetchTime = moment().format('HH:mm:ss')
    },
    currency (amount) {
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        return `${amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      }
    },
    req_return_trans (wd_id, username) {
      this.withdrawdata.wd_id = wd_id
      this.withdrawdata.username = username
      this.popup_confirm = true
    },
    clear_data () {
      this.withdrawdata.wd_id = ''
      this.withdrawdata.username = ''
    },
    async confirm () {
      this.popup_confirm = false
      await axios
        .post('withdraw/movetranswithdraw', {
          wd_id : this.withdrawdata.wd_id,
          status: 'moveInWaitWithdraw'
        })
        .then((response) => (this.status_wd = response.data))
      if (this.status_wd.status === true) {
        this.$vs.notify({
          time: 3000,
          color: 'success',
          position: 'top-right',
          icon: 'check_box',
          title: 'ยกเลิกถอนสำเร็จ',
          text: this.status_wd.info
        })
        this.clear_data()
      } else {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'ยกเลิกถอนไม่สำเร็จ',
          text: this.status_wd.info
        })
      }
      await this.get_data()
    }
  },
  async mounted () {
    await this.get_data()
  }
}
</script>

<style lang="scss" scooped>
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
div.ag-root .ag-cell-focus {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
#page-withdraw-wait .wd-last-fetch {
  font-size: 12px;
  opacity: 0.6;
  white-space: nowrap;
  align-self: center;
}
</style>
